module.exports = __webpack_public_path__ + "static/media/imgGallery1.294c1599.jpg";